import { Link } from 'react-router-dom';
import Project from '../Project/Project';
import projects from '../../utils/products.mock.js';
import './Proyects.scss';

const Proyects = () => {
    return (
        <section className='proyects'>
            <div className='proyects__content'>
                <div className='proyects__content__subtitle text'>
                    - qué hago -
                </div>
                <h2 className='proyects__content__title'>Proyectos que realicé</h2>
                <div className='proyects__content__group'>
                    <div className='proyects__content__group--left'>
                        <Project data={projects[0][0]}/>
                        <Project data={projects[0][1]}/>
                    </div>
                    <div className='proyects__content__group--right'>
                        <Project data={projects[0][2]}/>
                        <Project data={projects[1][0]}/>
                    </div>
                </div>
                <div className='proyects__content__more'>
                    <Link to='/portafolio'>
                        Ver más proyectos
                        <img src='./assets/icons/arrow-right.svg' alt='icono de flecha a la derecha'/>
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default Proyects;